import React from "react";

function FourOFour() {
  return <div>FourOFour</div>;
}

export default FourOFour;
